import './ContextMenuColumnItems.d04c1f9097b1e7bf20cb0a7601b6cd7b.css';
export default {"separator":"_separator_j63jp_1"};